(() => {
  const addMonths = (value, count) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return '';
    const [year, month, day] = value.split('-').map(Number);
    const target = new Date(Date.UTC(year, month - 1 + count, 1));
    const last = new Date(Date.UTC(target.getUTCFullYear(), target.getUTCMonth() + 1, 0)).getUTCDate();
    target.setUTCDate(Math.min(day, last));
    return target.toISOString().slice(0, 10);
  };
  function initialize(root) {
    if (root.dataset.initialized || !root.querySelector('[data-fr-form]')) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-fr-form]');
    const copy = JSON.parse(root.querySelector('[data-fr-copy]').textContent);
    const status = root.querySelector('[data-fr-status]');
    const completed = root.querySelector('[data-fr-completed]');
    const source = root.querySelector('[data-fr-source]');
    const submit = root.querySelector('[data-fr-submit]');
    const send = root.querySelector('[data-fr-send]');
    const verify = root.querySelector('[data-fr-verify]');
    const field = name => form.elements.namedItem(name);
    let fingerprint = '', token = '', challenge = '', submissionKey = '', previewId = '', previewToken = '', locked = false, endEdited = false, generation = 0;
    const reviewDownload = root.querySelector('[data-fr-review-download]');
    const signedDownload = root.querySelector('[data-fr-signed-download]');
    const servicePdf = value => { const url = new URL(value); const base = new URL(endpoint); if (url.origin !== base.origin || url.pathname !== base.pathname || !['preview','agreement'].includes(url.searchParams.get('document'))) throw new Error('Invalid document URL'); return url.href; };
    const serviceError = error => copy[error.message] || copy.failure;
    const notice = root.querySelector('[data-fr-verify-notice]');
    const verificationStatus = root.querySelector('[data-fr-verification-status]');
    const signatureHint = root.querySelector('[data-fr-signature-hint]');
    const signatureError = root.querySelector('[data-fr-signature-error]');
    const readyStatus = root.querySelector('[data-fr-sign-ready]');
    let verificationTimer;
    const fullName = () => `${field('first_name').value.trim()} ${field('last_name').value.trim()}`.replace(/\s+/g, ' ');
    const signatureMatches = () => field('signature').value.trim().replace(/\s+/g, ' ') === fullName();
    const refreshSigning = () => {
      signatureHint.textContent = copy.signature_name_hint.replace('{name}', fullName());
      const mismatch = !!field('signature').value.trim() && !signatureMatches();
      signatureError.textContent = mismatch ? copy.signature_name_error : '';
      field('signature').setAttribute('aria-invalid', String(mismatch));
      const missing = [];
      if (!token) missing.push(copy.need_email);
      if (!signatureMatches()) missing.push(copy.need_signature);
      if (!['authority','agreement','english_choice'].every(name => field(name)?.checked)) missing.push(copy.need_consents);
      readyStatus.textContent = missing.length ? copy.sign_remaining.replace('{items}', missing.join('; ')) : copy.ready_sign;
      submit.disabled = locked || !endpoint || !token || !fingerprint || !validateSilent();
    };
    notice.querySelector('[data-fr-verify-notice-close]').addEventListener('click', () => { notice.close(); field('verification_code').focus(); });
    notice.addEventListener('close', () => { if (!field('verification_code').disabled) field('verification_code').focus(); });
    let endpoint = '';
    try {
      if (root.dataset.endpoint) {
        const url = new URL(root.dataset.endpoint);
        if (url.protocol === 'https:' && !url.username && !url.password && !url.search && !url.hash) endpoint = url.href.replace(/\/$/, '');
      }
    } catch (_) {}
    if (endpoint) {
      root.querySelector('[data-fr-preview]').hidden = true;
      send.disabled = false;
    }
    const model = () => field('model').value;
    const details = () => {
      const result = { model: model(), campaign_theme: themeValues() };
      root.querySelectorAll('[data-fr-field]').forEach(input => {
        if (!input.disabled && input.name !== 'email_repeat' && (input.type !== 'radio' || input.checked)) result[input.name] = input.value.trim();
      });
      return result;
    };
    const showStatus = message => { status.textContent = message; };
    const reveal = step => {
      const target = root.querySelector(`[data-fr-step="${step}"]`);
      target.hidden = false;
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    };
    const invalidate = () => {
      const hadReview = !!fingerprint;
      fingerprint = ''; token = ''; challenge = ''; submissionKey = ''; previewId = ''; previewToken = ''; generation++;
      clearTimeout(verificationTimer); verificationStatus.textContent = ''; signatureError.textContent = ''; readyStatus.textContent = '';
      send.disabled = !endpoint;
      reviewDownload.hidden = true; reviewDownload.removeAttribute('href');
      root.querySelector('[data-fr-step="5"]').hidden = true;
      completed.hidden = true;
      root.querySelector('[data-fr-print]').hidden = true;
      root.querySelector('[data-fr-next="5"]').hidden = true;
      submit.disabled = true;
      field('verification_code').value = '';
      field('verification_code').disabled = true;
      verify.disabled = true;
      ['authority', 'agreement', 'english_choice'].forEach(name => { if (field(name)) field(name).checked = false; });
      field('signature').value = '';
      if (hadReview) showStatus(copy.review_again);
    };
    const updateOrganizationType = () => {
      const other = field('org_type').value === 'other';
      root.querySelector('[data-fr-other-type]').hidden = !other;
      field('org_type_other').disabled = !other;
    };
    const themePicker = root.querySelector('[data-fr-theme-picker]');
    const themeInputs = [...root.querySelectorAll('[data-fr-theme-option]')];
    const themeValues = () => themeInputs.filter(input => input.checked).map(input => input.value);
    const themeLabel = value => themeInputs.find(input => input.value === value)?.closest('label').querySelector('span').textContent || value;
    const updateTheme = () => {
      const selected = themeValues();
      themeInputs.forEach(input => { input.disabled = !input.checked && selected.length >= 3; });
      const other = selected.includes('other');
      root.querySelector('[data-fr-other-theme]').hidden = !other;
      field('campaign_theme_other').disabled = !other;
      const label = selected.length ? selected.map(themeLabel).join('; ') : copy.choose_theme;
      root.querySelector('[data-fr-theme-selection]').textContent = label;
      root.querySelector('[data-fr-theme-selection]').dataset.empty = String(!selected.length);
      root.querySelector('[data-fr-theme-selection]').title = label;
      root.querySelector('[data-fr-theme-count]').textContent = `${selected.length}/3`;
      root.querySelector('[data-fr-theme-status]').textContent = selected.length >= 3 ? copy.themes_limit : copy.themes_selected.replace('{count}', selected.length);
      themePicker.querySelector('summary').removeAttribute('aria-invalid');
    };
    const validateThemes = () => {
      if (themeValues().length >= 1 && themeValues().length <= 3) return true;
      showStatus(copy.themes_required);
      openField(themeInputs[0]); themePicker.open = true;
      themePicker.querySelector('summary').setAttribute('aria-invalid', 'true');
      themeInputs[0].focus(); return false;
    };
    themePicker.addEventListener('keydown', event => {
      if (event.key === 'Escape' && themePicker.open) { event.preventDefault(); event.stopPropagation(); themePicker.open = false; themePicker.querySelector('summary').focus(); }
    });
    root.addEventListener('click', event => { if (themePicker.open && !themePicker.contains(event.target)) themePicker.open = false; }, true);
    const groups = [...root.querySelectorAll('[data-fr-group]')];
    const mobile = window.matchMedia('(max-width: 749px)');
    const singlePickers = [];
    root.querySelectorAll('.cs-fr-compact-grid select').forEach(select => {
      const native = select.closest('.select'); native.classList.add('cs-fr-single-native');
      const label = root.querySelector(`label[for="${select.id}"]`);
      if (!label.id) label.id = `${select.id}-label`;
      const picker = document.createElement('details'); picker.className = 'cs-fr-single-picker';
      picker.dataset.frSingle = select.name;
      const trigger = document.createElement('summary'); trigger.className = 'cs-fr-theme-trigger';
      trigger.id = `${select.id}-mobile-trigger`; trigger.setAttribute('role', 'button');
      const selection = document.createElement('span'); selection.id = `${select.id}-mobile-selection`;
      trigger.setAttribute('aria-labelledby', `${label.id} ${selection.id}`);
      const caret = themePicker.querySelector('.svg-wrapper').cloneNode(true);
      trigger.append(selection, caret);
      const panel = document.createElement('div'); panel.className = 'cs-fr-theme-panel';
      panel.id = `${select.id}-mobile-options`; panel.setAttribute('role','group'); panel.setAttribute('aria-labelledby',label.id);
      trigger.setAttribute('aria-controls', panel.id);
      [...select.options].filter(option => option.value).forEach(option => {
        const choice = document.createElement('label'); choice.className = 'cs-fr-theme-option';
        const radio = document.createElement('input'); radio.type = 'radio'; radio.name = `${select.name}_mobile_choice`; radio.value = option.value;
        const text = document.createElement('span'); text.textContent = option.textContent;
        choice.append(radio, text); panel.append(choice);
        radio.addEventListener('change', () => {
          select.value = radio.value; select.dispatchEvent(new Event('input', {bubbles:true}));
          select.dispatchEvent(new Event('change', {bubbles:true}));
          picker.open = false; trigger.removeAttribute('aria-invalid'); trigger.focus();
        });
      });
      picker.append(trigger, panel); native.after(picker);
      const sync = () => {
        selection.textContent = select.selectedOptions[0]?.textContent || '';
        panel.querySelectorAll('input').forEach(radio => { radio.checked = radio.value === select.value; });
      };
      select.addEventListener('input', sync); select.addEventListener('change', sync); sync();
      picker.addEventListener('keydown', event => { if (event.key === 'Escape') {event.preventDefault(); event.stopPropagation(); picker.open = false; trigger.focus();} });
      root.addEventListener('click', event => { if (!picker.contains(event.target)) picker.open = false; }, true);
      trigger.addEventListener('click', () => { themePicker.open=false; singlePickers.forEach(item => {if (item.picker !== picker) item.picker.open=false;}); });
      singlePickers.push({select, picker, trigger, panel});
    });
    const reportInvalid = input => {
      const item = singlePickers.find(item => item.select === input);
      if (item && mobile.matches) {
        openField(input); item.picker.open = true; item.trigger.setAttribute('aria-invalid','true'); item.panel.querySelector('input')?.focus();
      } else { input.reportValidity(); }
    };
    themePicker.querySelector('summary').addEventListener('click', () => {singlePickers.forEach(item=>{item.picker.open=false;});});

    const openField = input => { const group = input.closest('[data-fr-group]'); if (group) group.open = true; };
    const groupSummary = () => {
      const summaryFields = [['legal_name','team','campaign_theme'],['address_line1','city','province'],['first_name','last_name','email'],['official_name','official_email']];
      groups.forEach((group, index) => {
        const values = summaryFields[index].map(name => {
          if (name === 'campaign_theme') return themeValues().map(themeLabel).join('; ');
          const input = field(name);
          return input.value.trim() ? (input.tagName === 'SELECT' ? input.selectedOptions[0].textContent : input.value.trim()) : '';
        }).filter(Boolean);
        group.querySelector('[data-fr-group-status]').textContent = values.join(' · ') || copy.tap_to_fill;
      });
    };
    const adaptGroups = () => { singlePickers.forEach(item => {item.picker.open=false;}); groups.forEach((group, index) => { group.open = !mobile.matches || index === 0; }); };
    groups.forEach((group,index) => {
      group.querySelector('summary').addEventListener('click', event => { if (!mobile.matches) event.preventDefault(); });
      group.querySelector('[data-fr-group-next]')?.addEventListener('click', () => {
        const inputs = [...group.querySelectorAll('input,textarea,select')].filter(input => !input.disabled);
        const invalid = inputs.find(input => !input.checkValidity() || (input.required && !input.value.trim()));
        if (invalid) { showStatus(copy.required); reportInvalid(invalid); return; }
        if (group.dataset.frGroup === 'organization' && !validateThemes()) return;
        if (group.dataset.frGroup === 'representative' && field('email').value.trim().toLowerCase() !== field('email_repeat').value.trim().toLowerCase()) {
          showStatus(copy.email_mismatch); field('email_repeat').focus(); return;
        }
        showStatus(''); groupSummary();
        if (mobile.matches && groups[index + 1]) { group.open = false; groups[index + 1].open = true; groups[index + 1].querySelector('summary').focus(); }
      });
    });
    mobile.addEventListener('change', adaptGroups);
    adaptGroups();
    const updateResalePayment = () => {
      const method = field('resale_payment_method').value;
      const resale = model() === 'resale';
      root.querySelector('[data-fr-card-payment]').hidden = !resale || method !== 'card';
      root.querySelector('[data-fr-manual-payment]').hidden = !resale || !['bank_transfer', 'interac', 'cheque'].includes(method);
    };
    const updateModel = () => {
      const online = model() === 'online';
      const onlineFields = root.querySelector('[data-fr-online-fields]');
      onlineFields.hidden = !online;
      onlineFields.querySelectorAll('input').forEach(input => { input.disabled = !online; });
      const resaleFields = root.querySelector('[data-fr-resale-fields]');
      const resale = model() === 'resale';
      resaleFields.hidden = !resale;
      resaleFields.querySelectorAll('input').forEach(input => { input.disabled = !resale; });
      updateResalePayment();
      field('read_conditions').checked = false;
      const summary = root.querySelector('[data-fr-model-summary]');
      summary.replaceChildren();
      source.querySelectorAll('[data-fr-model]').forEach(part => {
        if (part.dataset.frModel === model()) summary.append(part.cloneNode(true));
      });
    };
    const validate = upto => {
      const eligible = [...form.querySelectorAll('input,textarea,select')].filter(input => {
        const step = input.closest('[data-fr-step]');
        return step && Number(step.dataset.frStep) <= upto && !input.disabled;
      });
      const invalid = eligible.find(input => !input.checkValidity() || (input.required && input.type !== 'checkbox' && input.type !== 'radio' && !input.value.trim()));
      if (invalid) { showStatus(copy.required); openField(invalid); reportInvalid(invalid); return false; }
      if (upto >= 1) {
        if (!validateThemes()) return false;
        if (field('email').value.trim().toLowerCase() !== field('email_repeat').value.trim().toLowerCase()) { showStatus(copy.email_mismatch); openField(field('email_repeat')); field('email_repeat').focus(); return false; }
      }
      if (upto >= 3) {
        if (!field('start').value || field('end').value <= field('start').value) { showStatus(copy.date_error); field('end').focus(); return false; }
      }
      return true;
    };
    const appendEntry = (list, key, value) => {
      const dt = document.createElement('dt'); dt.textContent = copy[key] || key;
      const dd = document.createElement('dd'); dd.textContent = value;
      list.append(dt, dd);
    };
    form.addEventListener('input', event => {
      if (locked) return;
      if (event.target.matches('[data-fr-field],[name="model"],[data-fr-theme-option]')) {
        if (event.target.name === 'end') endEdited = true;
        if (event.target.name === 'start' && !endEdited) field('end').value = addMonths(field('start').value, 3);
        invalidate();
      }
      if (event.target.name === 'org_type') updateOrganizationType();
      if (event.target.name === 'resale_payment_method') updateResalePayment();
      if (event.target.matches('[data-fr-theme-option]')) updateTheme();
      groupSummary();
      if (event.target.name === 'read_conditions') invalidate();
      if (event.target.name === 'verification_code') field('verification_code').value = field('verification_code').value.replace(/[\s\u200B-\u200D\uFEFF]/g, '');
      if (['signature', 'authority', 'agreement', 'english_choice'].includes(event.target.name)) refreshSigning();
    });
    function validateSilent() {
      const expected = `${field('first_name').value.trim()} ${field('last_name').value.trim()}`.replace(/\s+/g, ' ');
      return field('read_conditions').checked && field('signature').value.trim().replace(/\s+/g, ' ') === expected && field('authority').checked && field('agreement').checked && (!field('english_choice') || field('english_choice').checked);
    }
    form.addEventListener('change', event => { if (event.target.name === 'model') updateModel(); });
    root.querySelectorAll('[data-fr-next]').forEach(button => button.addEventListener('click', () => {
      const step = Number(button.dataset.frNext);
      if (step === 5 && !fingerprint) return;
      if (validate(step - 1)) { showStatus(''); reveal(step); if (step === 5) refreshSigning(); }
    }));
    root.querySelector('[data-fr-review]').addEventListener('click', async event => {
      if (!endpoint || !validate(3)) return;
      invalidate();
      const data = details(), expected = JSON.stringify(data), revision = generation;
      const button = event.currentTarget; button.disabled = true; showStatus(copy.preview_loading);
      try {
      const result = await request('/previews', {details:data, version:root.dataset.version});
      if (revision !== generation || expected !== JSON.stringify(details())) { showStatus(copy.review_again); return; }
      if (!result.previewId || !result.previewToken || result.version !== root.dataset.version) throw new Error('Invalid preview');
      reviewDownload.href = servicePdf(result.pdfUrl); reviewDownload.hidden = false;
      previewId = result.previewId; previewToken = result.previewToken;
      fingerprint = expected; submissionKey = crypto.randomUUID();
      completed.replaceChildren();
      const heading = document.createElement('h2'); heading.textContent = copy.pending;
      completed.append(heading);
      const created = document.createElement('p');
      const date = new Intl.DateTimeFormat(root.dataset.locale === 'fr' ? 'fr-CA' : 'en-CA', {year:'numeric',month:'long',day:'numeric',timeZone:'America/Toronto'}).format(new Date(result.createdAt));
      created.textContent = copy.created_date.replace('{date}', date);
      const version = document.createElement('p'); version.className = 'cs-fr-help'; version.textContent = copy.terms_version;
      completed.append(created, version);
      const info = document.createElement('dl');
      Object.entries(data).forEach(([key, value]) => {
        const input = field(key);
        const label = key === 'resale_payment_method' ? copy['payment_' + value] : Array.isArray(value) ? value.map(themeLabel).join('; ') : key === 'model' ? copy[value] : input?.tagName === 'SELECT' ? input.selectedOptions[0].textContent : value;
        if (value) appendEntry(info, key, label);
      });
      appendEntry(info, 'appendix', copy.unconfirmed);
      completed.append(info);
      const terms = source.cloneNode(true); terms.removeAttribute('data-fr-source');
      terms.querySelectorAll('[data-fr-model]').forEach(part => { if (part.dataset.frModel !== model()) part.remove(); });
      completed.append(terms);
      completed.hidden = false;
      root.querySelector('[data-fr-print]').hidden = false;
      root.querySelector('[data-fr-next="5"]').hidden = false;
      showStatus(''); completed.focus();
      } catch (error) { showStatus(serviceError(error)); } finally { button.disabled = false; }
    });
    root.querySelector('[data-fr-print]').addEventListener('click', () => { if (fingerprint) window.print(); });
    const request = async (path, payload) => {
      const response = await fetch(endpoint + '?action=' + encodeURIComponent(path.slice(1)), { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload), signal: AbortSignal.timeout(20000) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.error || 'failure');
      return result;
    };
    send.addEventListener('click', async () => {
      if (!endpoint || !fingerprint || token || send.disabled || !validate(3)) return;
      send.disabled = true;
      let cooldown = false;
      const expected = fingerprint;
      try {
        const result = await request('/verify/start', { previewId, previewToken, locale: root.dataset.locale, version: root.dataset.version });
        if (expected !== fingerprint) return;
        if (!result.challengeId) throw new Error('Missing challenge');
        challenge = result.challengeId;
        field('verification_code').disabled = false;
        verify.disabled = false;
        const message = copy.verify_sent.replace('{email}', field('email').value.trim());
        verificationStatus.textContent = message; showStatus('');
        notice.querySelector('[data-fr-verify-notice-message]').textContent = message;
        if (!notice.open) notice.showModal();
        cooldown = true;
        setTimeout(() => { send.disabled = !!token || locked || !endpoint; }, 60000);
      } catch (error) { showStatus(serviceError(error)); } finally { if (!cooldown) send.disabled = !!token || !endpoint; }
    });
    verify.addEventListener('click', async () => {
      if (!endpoint || !challenge || token || verify.disabled) return;
      const code = field('verification_code').value.replace(/[\s\u200B-\u200D\uFEFF]/g, '');
      if (!/^[0-9]{6}$/.test(code)) { verificationStatus.textContent = copy.code_format; return; }
      field('verification_code').value = code; verify.disabled = true;
      const expected = fingerprint;
      try {
        const result = await request('/verify/confirm', { challengeId: challenge, email: field('email').value.trim(), code });
        if (expected !== fingerprint) return;
        if (!result.token || result.email?.toLowerCase() !== field('email').value.trim().toLowerCase()) throw new Error('Verification mismatch');
        token = result.token;
        field('verification_code').disabled = true; send.disabled = true;
        verificationStatus.textContent = copy.verified_email.replace('{email}', result.email);
        showStatus(''); refreshSigning();
        clearTimeout(verificationTimer);
        verificationTimer = setTimeout(() => { token = ''; challenge = ''; send.disabled = !endpoint; verificationStatus.textContent = copy.verify_expired; refreshSigning(); }, 29 * 60 * 1000);
      } catch (error) { verificationStatus.textContent = serviceError(error); } finally { verify.disabled = !!token || !challenge; }
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (locked || !endpoint || !token || !fingerprint) return;
      if (fingerprint !== JSON.stringify(details())) { invalidate(); return; }
      if (!validateSilent()) { showStatus(copy.signature_error); return; }
      locked = true; submit.disabled = true; showStatus(copy.signing);
      const signature = field('signature').value.trim(), englishChoice = field('english_choice').checked;
      const controls = [...form.querySelectorAll('input,textarea,select,button')].map(input => ({input, disabled:input.disabled}));
      controls.forEach(({input}) => { input.disabled = true; });
      try {
        const result = await request('/agreements', { previewId, previewToken, idempotencyKey: submissionKey, details: JSON.parse(fingerprint), verificationToken: token, version: root.dataset.version, locale: root.dataset.locale, signature, authority: true, accepted: true, englishChoice });
        if (!result.agreementId || result.status !== 'pending_approval') throw new Error('Unconfirmed submission');
        signedDownload.href = servicePdf(result.pdfUrl); signedDownload.hidden = false;
        showStatus(`${result.deliveryStatus === 'handed_off' ? copy.submitted : copy.mail_pending} ${copy.reference}: ${result.agreementId}`); status.focus();
      } catch (error) { locked = false; controls.forEach(({input,disabled}) => { input.disabled = disabled; }); submit.disabled = false; showStatus(serviceError(error)); }
    });
    updateOrganizationType();
    updateTheme();
    groupSummary();
    updateModel();
  }
  document.querySelectorAll('[data-fundraising]').forEach(initialize);
  document.addEventListener('cansweet:deferred:ready', event => { const root = event.target.closest('[data-fundraising]'); if (root) initialize(root); });
  document.addEventListener('shopify:section:load', event => { event.target.querySelectorAll('[data-fundraising]').forEach(initialize);  });
})();




